<template>
  <div>
    <el-tree
      ref="sopTree"
      :data="treeData"
      show-checkbox
      node-key="id"
      :props="defaultProps"
      :default-checked-keys="checkedKey"
    />
  </div>
</template>
<script>
import { getSopNodeTree, postSopNodeConfig } from '@/api/sop'
export default {
  data() {
    return {
      treeData: [],
      defaultProps: {
        children: 'children',
        label: this.$store.getters.isZh ? 'name' : 'eName'
      },
      checkedKey: [],
      data: []
    }
  },
  created() {
    this.getSopNodeTree()
  },
  methods: {
    async getSopNodeTree() {
      const res = await getSopNodeTree({ branchId: this.$store.getters.currentOfficeId })
      console.log('getSopNodeTree', res)
      const data = res.data
      this.getCheckedNodes(data)
      this.getTreeData(data)
    },
    getCheckedNodes(data) {
      const dataCopy = JSON.parse(JSON.stringify(data))
      console.log('getCheckedNodes', dataCopy)
      this.checkedKey = dataCopy.filter(item => {
        const firstNode = ['0', '1', '2', '3', '4']
        return item.selected && !firstNode.includes(item.parentId)
      }).map(item1 => {
        return item1.id
      })
      console.log('checkedKey', this.checkedKey)
    },
    getTreeData(data) {
      console.log(data)
      const dataCopy = data
      const idMapping = dataCopy.reduce((prev, next, i) => {
        prev[next.id] = i
        return prev
      }, {})
      const treeData = []
      dataCopy.map(el => {
        // 一级菜单
        if (el.parentId === '') {
          treeData.push(el)
          return
        }
        // 通过映射找到父元素
        const parentEl = data[idMapping[el.parentId]]
        // 把当前元素添加到父元素的children数组中
        if (parentEl) {
          parentEl.children = [...(parentEl.children || []), el]
        }
      })
      this.treeData = treeData
      console.log(treeData)
    },
    async saveCheckedSopNode() {
      const checkedNodes = this.$refs.sopTree.getCheckedNodes()
      // 只留下单个节点
      const filterCheckedNodes = checkedNodes.filter(item => {
        return !item.children
      })
      console.log(filterCheckedNodes)
      const tmp = {}
      filterCheckedNodes.forEach((item) => {
        const { lob, parentId } = item
        const key = `${lob}${parentId}`
        if (!tmp[key]) {
          tmp[key] = {
            trackId: item.parentId,
            lob,
            templateKey: item.templateKey,
            trackDetailIds: []
          }
        }
        tmp[key].trackDetailIds.push(item.id)
      })
      console.log(tmp)
      const data = Object.values(tmp)
      await this.postSopNodeConfig(data)
    },
    async postSopNodeConfig(data) {
      const res = await postSopNodeConfig(data)
      if (res.code === '0') {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
      }
    }
  }
}

</script>
